import React from 'react';

class CheckboxAnswers extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e, isChecked) {
    let questionData = this.props.questionData;
    if (this.props.onChange) {
      this.props.onChange(e.target.value, questionData, "answer_ids", isChecked);
    }
  }

  render() {
    let { questionData } = this.props;
    return(
      <div>
        {questionData.answers.map((answer) => {
          let isCurrentlyChecked = (this.props.answerIds && this.props.answerIds.includes(answer.id.toString()));
          return(
            <div key={`answer-${answer.id}`}>
              <label className='survey-answer-label'>
                <input
                  onChange={(e) => isCurrentlyChecked ? this.handleChange(e, false) : this.handleChange(e, true)}
                  type="checkbox"
                  checked={isCurrentlyChecked}
                  disabled={this.props.disabled}
                  value={answer.id}
                  className="mr1"
                />
                {answer.answer}
              </label>
            </div>
          )
        })}
      </div>
    )
  }
}

export default CheckboxAnswers;
